import React from 'react';
import { Box, Button, CircularProgress, Paper, TextField, Typography } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { useSuperDuper } from '../context/SuperDuperContext';

const WhatsAppTab = () => {
  const {
    whatsappForm,
    setWhatsappForm,
    whatsappSending,
    isValidWhatsappPhone,
    handleSendWhatsAppSingle
  } = useSuperDuper();

  return (
    <Box sx={{ mt: { xs: 1, sm: 2, md: 4 }, maxWidth: 480, width: '100%' }}>
      <Typography
        variant="h5"
        sx={{
          color: '#c64110',
          fontWeight: 700,
          mb: 1,
          fontSize: { xs: '1.25rem', sm: '1.5rem' }
        }}
      >
        Send WhatsApp Message
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
        Send the configured WhatsApp template to a single phone number, with a UTM code appended to the CTA link.
      </Typography>
      <Paper sx={{ p: { xs: 2, sm: 3 } }}>
        <TextField
          fullWidth
          label="Phone Number"
          placeholder="91XXXXXXXXXX"
          value={whatsappForm.phone}
          onChange={(e) => setWhatsappForm(prev => ({ ...prev, phone: e.target.value.replace(/\D/g, '').slice(0, 12) }))}
          error={whatsappForm.phone.length > 0 && !isValidWhatsappPhone(whatsappForm.phone)}
          helperText={
            whatsappForm.phone.length > 0 && !isValidWhatsappPhone(whatsappForm.phone)
              ? 'Enter a valid number in the format 91XXXXXXXXXX'
              : 'Include the 91 country code, e.g. 919876543210'
          }
          inputProps={{ inputMode: 'numeric' }}
          sx={{ mb: 3 }}
        />
        <TextField
          fullWidth
          label="UTM Code"
          value={whatsappForm.utmCode}
          onChange={(e) => setWhatsappForm(prev => ({ ...prev, utmCode: e.target.value }))}
          helperText="Appended to the CTA link as utm_campaign"
          sx={{ mb: 3 }}
        />
        <Button
          variant="contained"
          fullWidth
          startIcon={whatsappSending ? <CircularProgress size={18} color="inherit" /> : <SendIcon />}
          disabled={whatsappSending || !isValidWhatsappPhone(whatsappForm.phone)}
          onClick={handleSendWhatsAppSingle}
          sx={{ maxWidth: { sm: 220 } }}
        >
          {whatsappSending ? 'Sending...' : 'Send Message'}
        </Button>
      </Paper>
    </Box>
  );
};

export default WhatsAppTab;
